import React from 'react'

function Experience() {
    return (
        <div>
            <h1 className='experience'>Experience</h1>
        </div>
    )
}

export default Experience

